import React, { useState } from "react";

const regexChallenges = [
    {
        question: "Quale regex trova SOLO numeri?",
        options: ["[0-9]+", "[a-z]+", "\\w+", ".*"],
        correct: 0,
        explanation: "[0-9]+ trova una o più cifre numeriche"
    },
    {
        question: "Regex per email valide?",
        options: [".*@.*", "\\w+@\\w+\\.\\w+", "[a-z]@[a-z]", "\\d+@\\d+"],
        correct: 1,
        explanation: "\\w+@\\w+\\.\\w+ è la forma base per email"
    },
    {
        question: "Come trovare stringhe che iniziano con 'A'?",
        options: ["A.*", "^A", "*A", "A$"],
        correct: 1,
        explanation: "^ indica l'inizio della stringa"
    },
    {
        question: "Regex per trovare 'ciao' o 'hello'?",
        options: ["ciao|hello", "ciao+hello", "ciao,hello", "ciao&hello"],
        correct: 0,
        explanation: "| è l'operatore OR nelle regex"
    },
    {
        question: "Come trovare esattamente 3 cifre?",
        options: ["\\d+", "\\d{3}", "\\d*", "\\d?"],
        correct: 1,
        explanation: "{3} specifica esattamente 3 occorrenze"
    }
];

export default function RegexQuiz() {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [score, setScore] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [started, setStarted] = useState(false);
    const [showExplanation, setShowExplanation] = useState(false);

    const handleAnswer = (index) => {
        setSelectedAnswer(index);
        setShowExplanation(true);

        if (index === regexChallenges[currentQuestion].correct) {
            setScore(score + 1);
        }

        setTimeout(() => {
            if (currentQuestion + 1 < regexChallenges.length) {
                setCurrentQuestion(currentQuestion + 1);
                setSelectedAnswer(null);
                setShowExplanation(false);
            } else {
                setShowResult(true);
            }
        }, 2000);
    };

    const restart = () => {
        setCurrentQuestion(0);
        setScore(0);
        setShowResult(false);
        setSelectedAnswer(null);
        setStarted(false);
        setShowExplanation(false);
    };

    if (!started) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-asterisk" style={{marginRight:"6px"}}></i> Regex Quiz
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>
                    Testa le tue conoscenze sulle espressioni regolari!
                </p>
                <button
                    onClick={() => setStarted(true)}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (showResult) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Quiz Completato!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    {score}/{regexChallenges.length}
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score === regexChallenges.length && "🎉 Regex Master!"}
                    {score >= 3 && score < regexChallenges.length && "👍 Ottima conoscenza!"}
                    {score < 3 && "📚 Continua a studiare le regex!"}
                </p>
                <button
                    onClick={restart}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Riprova
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{marginBottom:"1rem", color:"#94a3b8", fontSize:"0.85rem"}}>
                Domanda {currentQuestion + 1} di {regexChallenges.length}
            </div>

            <h4 style={{color:"#facc15", marginBottom:"1.5rem", fontSize:"1rem", lineHeight:"1.4"}}>
                {regexChallenges[currentQuestion].question}
            </h4>

            <div style={{display:"flex", flexDirection:"column", gap:"0.8rem"}}>
                {regexChallenges[currentQuestion].options.map((option, index) => {
                    const isSelected = selectedAnswer === index;
                    const isCorrect = index === regexChallenges[currentQuestion].correct;
                    const showFeedback = selectedAnswer !== null;

                    return (
                        <button
                            key={index}
                            onClick={() => selectedAnswer === null && handleAnswer(index)}
                            disabled={selectedAnswer !== null}
                            style={{
                                padding:"0.8rem",
                                borderRadius:"0.5rem",
                                border: showFeedback
                                    ? (isCorrect ? "2px solid #22c55e" : isSelected ? "2px solid #ef4444" : "1px solid rgba(255,255,255,0.1)")
                                    : "1px solid rgba(255,255,255,0.1)",
                                background: showFeedback
                                    ? (isCorrect ? "rgba(34,197,94,0.2)" : isSelected ? "rgba(239,68,68,0.2)" : "rgba(255,255,255,0.05)")
                                    : "rgba(255,255,255,0.05)",
                                color:"#fff",
                                cursor: selectedAnswer === null ? "pointer" : "default",
                                fontSize:"0.9rem",
                                fontFamily:"monospace",
                                transition:"all 0.3s ease",
                                textAlign:"center"
                            }}
                        >
                            {showFeedback && isCorrect && <i className="fas fa-check" style={{marginRight:"6px", color:"#22c55e"}}></i>}
                            {showFeedback && isSelected && !isCorrect && <i className="fas fa-times" style={{marginRight:"6px", color:"#ef4444"}}></i>}
                            {option}
                        </button>
                    );
                })}
            </div>

            {showExplanation && (
                <div style={{
                    marginTop:"1rem",
                    padding:"0.8rem",
                    background:"rgba(59,130,246,0.1)",
                    borderRadius:"0.5rem",
                    fontSize:"0.8rem",
                    color:"#94a3b8",
                    border:"1px solid rgba(59,130,246,0.3)"
                }}>
                    <i className="fas fa-info-circle" style={{marginRight:"6px", color:"#3b82f6"}}></i>
                    {regexChallenges[currentQuestion].explanation}
                </div>
            )}
        </div>
    );
}